// extracted by mini-css-extract-plugin
export default {"writeReviewLink":"WriteReviewLink_writeReviewLink__o14ar"};